module.exports = __webpack_public_path__ + "img/7.c96815d3.png";